import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AlertController, ToastController, ModalController, IonicModule } from '@ionic/angular';
import { ITap } from 'app/models/tap';

import * as fromTap from "app/state/tap";
import * as fromCustomKegMon from "app/state/custom_keg_mon";
import * as fromKegtron from "app/state/kegtron";
import * as fromPlaato2 from "app/state/plaato2";
import * as fromStatistics from "app/state/statistics";
import * as fromUnits from "app/state/units";

import * as fromUser from "app/state/user";
import * as fromBar from "app/state/bar";
import * as fromKeg from "app/state/keg";
import { Store } from '@ngrx/store';
import { TapStatsComponent } from './tap-stats/tap-stats.component';
import { FormComponent } from './form/form.component';

import { HelpModalComponent } from 'app/components/help-modal/help-modal.component';


@Component({
  selector: 'app-tap-detail',
  templateUrl: './tap-detail.page.html',
  styleUrls: ['./tap-detail.page.scss'],
  standalone: true,
  imports: [
    IonicModule,
    RouterModule,
    TapStatsComponent,
    FormComponent
]
})
export class TapDetailPage {
  @Input() isModal!: boolean;

  bar = this.store.selectSignal(fromBar.selectBar);
  user = this.store.selectSignal(fromUser.selectUser);
  units = this.store.selectSignal(fromUnits.getUnits);
  allKegs = this.store.selectSignal(fromKeg.selectAllItems);
  allTaps = this.store.selectSignal(fromTap.selectAllItems);
  kegs = this.store.selectSignal(fromKeg.selectAllEntities);
  allPlaato2s = this.store.selectSignal(fromPlaato2.selectAllItems);
  allKegtrons = this.store.selectSignal(fromKegtron.selectAllItems);
  allCustomKegMons = this.store.selectSignal(fromCustomKegMon.selectAllItems);



  barId = this.store.selectSignal(fromUser.selectBarId);
  itemWithKeg = this.store.selectSignal(fromTap.selectCurrentItemWithKeg);
  statistics = this.store.selectSignal(fromStatistics.selectTop5ItemsFromCurrentTap);

  constructor(
    private store: Store,
    private modalController: ModalController,
    private router: Router,
    public alertController: AlertController,
    public toastController: ToastController,
  ) { }

  softUpdateKeg(event: any) {
    this.store.dispatch(fromKeg.softUpdate({ id: event.id, data: event.data, uid: event.uid }));
  }
  softUpdateTap(event: any) {
    this.store.dispatch(fromTap.softUpdate({ id: event.id, data: event.data, uid: event.uid }));
  }


  closeModal() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  async confirmAlert(tap: ITap) {
    const alert = await this.alertController.create({
      header: 'Confirm',
      message: 'Are you sure you want to delete?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
        },
        {
          text: 'Delete',
          handler: () => {
            this.delete(tap);
          },
        },
      ],
    });

    await alert.present();
  }


  private delete(tap: ITap) {
    this.store.dispatch(fromTap.deleteItem({ item: tap }));
    this.router.navigateByUrl('inventory/taps');
  }

  public async openHelpModal() {
    const modal = await this.modalController.create({
      component: HelpModalComponent,
      componentProps: {
        component: 'TapDetailPage'
      }
    });
    return await modal.present();
  }

}
